import type { QuyenChungTu } from '@/types/schemas';

// kieu_trung_so
// =0 : Không kiểm tra
// =1 : Kiểm tra theo ngày
// =2 : Kiểm tra theo tháng
// =3 : Kiểm tra theo quý
// =4 : Kiểm tra theo năm

export const getCurrentNumber = (quyenChungTu: QuyenChungTu | any, ngayCt: string): number => {
  const kieu_trung_so = Number(quyenChungTu?.kieu_trung_so);
  let i_so_ct_ht = quyenChungTu?.i_so_ct_ht || 0;

  if (!quyenChungTu?.ngay?.length) {
    return i_so_ct_ht + 1;
  }

  const currentDate = new Date(ngayCt);
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentQuarter = Math.ceil(currentMonth / 3);
  const currentDay = currentDate.getDate();

  let maxNumber = 0;

  switch (kieu_trung_so) {
    case 0: // Không kiểm tra
      maxNumber = Math.max(...quyenChungTu.ngay.map((item: any) => item.i_so_ct_ht));
      i_so_ct_ht = maxNumber;
      break;

    case 1: // Kiểm tra theo ngày
      const todayRecords = quyenChungTu.ngay.filter((item: any) => {
        const itemDate = new Date(item.ngay_nk);
        return (
          itemDate.getFullYear() === currentYear &&
          itemDate.getMonth() + 1 === currentMonth &&
          itemDate.getDate() === currentDay
        );
      });
      if (todayRecords.length > 0) {
        i_so_ct_ht = Math.max(...todayRecords.map((item: any) => item.i_so_ct_ht));
      } else {
        i_so_ct_ht = 0;
      }
      break;

    case 2: // Kiểm tra theo tháng
      const monthRecord = quyenChungTu.ngay.find((item: any) => {
        const itemDate = new Date(item.ngay_nk);
        return itemDate.getFullYear() === currentYear && itemDate.getMonth() + 1 === currentMonth;
      });
      i_so_ct_ht = monthRecord?.i_so_ct_ht || 0;
      break;

    case 3: // Kiểm tra theo quý
      const quarterRecord = quyenChungTu.ngay.find((item: any) => {
        const itemDate = new Date(item.ngay_nk);
        const itemQuarter = Math.ceil((itemDate.getMonth() + 1) / 3);
        return itemDate.getFullYear() === currentYear && itemQuarter === currentQuarter;
      });
      i_so_ct_ht = quarterRecord?.i_so_ct_ht || 0;
      break;

    case 4: // Kiểm tra theo năm
      const yearRecord = quyenChungTu.ngay.find((item: any) => {
        const itemDate = new Date(item.ngay_nk);
        return itemDate.getFullYear() === currentYear;
      });
      i_so_ct_ht = yearRecord?.i_so_ct_ht || 0;
      break;

    default:
      maxNumber = Math.max(...quyenChungTu.ngay.map((item: any) => item.i_so_ct_ht));
      i_so_ct_ht = maxNumber;
  }

  return i_so_ct_ht + 1;
};

export const transformDocumentNumber = (quyenChungTu: QuyenChungTu | any, soChungTu: string, maChungTu?: string) => {
  const pattern: string = quyenChungTu?.so_ct_mau || '';
  const buildRegexFromPattern = (pat: string): RegExp | null => {
    if (!pat || typeof pat !== 'string') return null;
    let regexStr = pat;
    regexStr = regexStr.replace(/\[(#+)\]/g, (_m, hashes: string) => {
      return `\\d{${hashes.length}}`;
    });
    regexStr = regexStr.replace(/\[(MM|YY|DD)\]/g, '\\d{2}');
    regexStr = regexStr.replace(/\./g, '\\.');
    regexStr = `^${regexStr}$`;
    try {
      return new RegExp(regexStr);
    } catch {
      return null;
    }
  };

  const fullRegex = buildRegexFromPattern(pattern);
  const isValid = !!fullRegex && fullRegex.test(soChungTu || '');
  console.log('soct', soChungTu);
  console.log('ma_nk', quyenChungTu?.so_ct_mau);
  console.log('isValid', isValid);
  if (!isValid) {
    return {
      ma_nk: null,
      so_ct: soChungTu || '',
      i_so_ct: 0,
      chung_tu: null
    };
  }

  const match = soChungTu?.match(/(\d+)$/);
  return {
    ma_nk: quyenChungTu?.uuid || null,
    so_ct: soChungTu || '',
    i_so_ct: Number(match?.[1]) || 0, // HD1.10.25.000123 -> 123
    chung_tu: quyenChungTu?.chi_tiet?.[0]?.chung_tu_uuid || undefined
  };
};
